import { Modal } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const RegisterUsers = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [roleListToBeSelect, setRoleListToBeSelect] = useState([]);
  const [roleList, setRoleList] = useState([]);
  // const [orgListToBeSelect, setOrgListToBeSelect] = useState([]);
  // const [orgList, setOrgList] = useState([]);

  const [addData, setAddData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [dataToBeSelect, setDataToBeSelect] = useState([]);

  // const userIdInputRef = useRef();
  const fullNameInputRef = useRef();
  const userNameInputRef = useRef();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const cPasswordInputRef = useRef();

  useEffect(() => {
    if (props.dataToBeSelect !== undefined && props.dataToBeSelect !== null) {
      setDataToBeSelect({
        Organization:
          props.dataToBeSelect.Organization === null
            ? []
            : props.dataToBeSelect.Organization,
      });
    }
  }, [props.dataToBeSelect]);

  const hideModal = () => {
    // setOrgList([]);
    setRoleList([]);
    setAddData([]);
    setInputError([]);
    props.onHide();
  };

  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Role List";
      http
        .get("api/users/GetRoleList?_user=" + userId)
        .then((response) => {
          const rolelist = [];
          for (var i = 0; i < response.data.length; i++) {
            rolelist.push({
              key: response.data[i].ROLE_ID,
              value: response.data[i].ROLE_ID,
              label: response.data[i].ROLE_NAME,
            });
          }
          setRoleListToBeSelect(rolelist);
        })
        .catch((err) => {
          common.c_LogWebError(props.page, functionName, err);
        });
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);

  const saveBtnOnClick = () => {
    var flag = true;
    if (addData.USER_ID === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        USER_ID: " User ID could not be empty.",
      }));
    }
    if (addData.USER_FULL_NAME === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        FULL_NAME: " Full Name could not be empty.",
      }));
    }

    if (addData.USER_SHORT_NAME === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        USER_NAME: " User Name could not be empty.",
      }));
    }

    if (addData.EMAIL !== undefined) {
      flag = furtherValidateInput("EMAIL", addData.EMAIL) && flag;
    }
    if (
      addData.ORGANIZATION === undefined ||
      Object.keys(addData.ORGANIZATION).length === 0
    ) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        ORGANIZATION: "Please select a organization.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        ORGANIZATION: "",
      }));
    }
    if (Object.keys(roleList).length === 0) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        USER_ROLE: "User role could not be empty.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        USER_ROLE: "",
      }));
    }
    if (addData.DEFAULT_PASSWORD === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        DEFAULT_PASSWORD: "Password could not be empty.",
      }));
    } else {
      flag = furtherValidateInput("DEFAULT_PASSWORD", addData.DEFAULT_PASSWORD);
    }
    if (
      Object.values(inputError).filter((v) => v !== "").length === 0 &&
      flag
    ) {
      RegisterNewUser();
    }
  };

  function RegisterNewUser() {
    let functionName = "";
    try {
      functionName = props.page + RegisterNewUser.name;
      props.onLoading(true, "Registering user, please wait...");
      var encrypted = common.c_EncryptData(addData.DEFAULT_PASSWORD.trim());
      const selectedRoleList = roleList.map((r) => r.key);
      const data = {
        // USER_ID: addData.USER_ID.trim(),
        USER_FULL_NAME: addData.USER_FULL_NAME.trim(),
        USER_SHORT_NAME: addData.USER_SHORT_NAME.trim(),
        EMAIL: addData.EMAIL.trim(),
        DEFAULT_PASSWORD: encrypted.toString(),
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
        USER_ROLE_LIST: selectedRoleList,
        // ORGANIZATION_LIST: selectedOrgList,
        ORG_ID: addData.ORGANIZATION.key,
        ORG_NAME: addData.ORGANIZATION.label,
      };
      http
        .post("api/users/RegisterUser", data, { timeout: 10000 })
        .then((response) => {
          // if (
          //   response.data.DUPLICATE_USER_ID === true &&
          //   response.data.DUPLICATE_EMAIL === true
          // ) {
          //   toast.error(
          //     "User ID " +
          //       response.data.USER_ID +
          //       " and email " +
          //       response.data.EMAIL +
          //       " already exist."
          //   );
          // } else if (response.data.DUPLICATE_USER_ID === true) {
          //   toast.error("User ID " + response.data.USER_ID + " already exist.");
          // } else
          if (response.data.DUPLICATE_EMAIL === true) {
            toast.error("Email " + response.data.EMAIL + " already exist.");
          } else {
            toast.success("User is successfully inserted.");
            props.onReload();
            hideModal();
          }
        })
        .catch((err) => {
          toast.error("Failed to insert user. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to insert user. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  const selectUserRoleHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectUserRoleHandler.name;
      if (Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          USER_ROLE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          USER_ROLE: "User role could not be empty.",
        }));
      }
      setRoleList([...val]);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = selectionHandler.name;
      setInputError((prevState) => ({
        ...prevState,
        [field]: "",
      }));
      setAddData((prevState) => ({
        ...prevState,
        [field]: val, //Document type
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  function furtherValidateInput(id, val) {
    if (id === "EMAIL") {
      if (!common.EMAIL_REGEX.test(val) && val !== "") {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "Please enter a proper email.",
        }));
        return false;
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
        return true;
      }
    } else if (id === "DEFAULT_PASSWORD") {
      var CONFIRM_PASSWORD = addData.CONFIRM_PASSWORD;

      if (CONFIRM_PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "Please confirm the passwords are match.",
        }));
        return false;
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "",
        }));
        return true;
      }
    } else if (id === "CONFIRM_PASSWORD") {
      var DEFAULT_PASSWORD = addData.DEFAULT_PASSWORD;
      if (DEFAULT_PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "Please confirm the passwords are match.",
        }));
        return false;
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: "",
        }));
        return true;
      }
    } else {
      return true;
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
        furtherValidateInput(id, val);
      }
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      furtherValidateInput(id, val);
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>REGISTER</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body autoComplete='off'>
          <Comp.Select
            id="ORGANIZATION"
            label="Organization*:"
            type="text"
            options={dataToBeSelect.Organization}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.ORGANIZATION}
            value={addData.ORGANIZATION}
            onChange={(val) => selectionHandler(val, "ORGANIZATION")}
          />
          {/* <Comp.Input
            ref={userIdInputRef}
            id="USER_ID"
            label="User ID*:"
            name="User ID"
            type="text"
            className="form-control"
            errorMessage={inputError.USER_ID}
            value={addData.USER_ID}
            onChange={inputRequiredHandler}
          /> */}
          <Comp.Input
            ref={fullNameInputRef}
            id="USER_FULL_NAME"
            label="Full Name*:"
            name="Full Name"
            type="text"
            className="form-control"
            errorMessage={inputError.USER_FULL_NAME}
            value={addData.USER_FULL_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={userNameInputRef}
            id="USER_SHORT_NAME"
            label="User Name*:"
            name="User Name"
            type="text"
            className="form-control"
            errorMessage={inputError.USER_SHORT_NAME}
            value={addData.USER_SHORT_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={emailInputRef}
            id="EMAIL"
            label="Email*:"
            name="Email"
            type="text"
            className="form-control"
            errorMessage={inputError.EMAIL}
            value={addData.EMAIL}
            onChange={inputRequiredHandler}
            autoComplete="off"
          />
          <Comp.Select
            id="USER_ROLE"
            label="User Role*:"
            type="text"
            options={roleListToBeSelect}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.USER_ROLE}
            value={roleList}
            onChange={selectUserRoleHandler}
            isMulti
            autoComplete="off"
          />
          <Comp.Input
            ref={passwordInputRef}
            id="DEFAULT_PASSWORD"
            label="Password*:"
            name="Password"
            type="password"
            className="form-control"
            errorMessage={inputError.DEFAULT_PASSWORD}
            value={addData.DEFAULT_PASSWORD}
            onChange={inputRequiredHandler}
            autoComplete="off"
          />
          <Comp.Input
            ref={cPasswordInputRef}
            id="CONFIRM_PASSWORD"
            label="Confirm Password*:"
            name="Password"
            type="password"
            className="form-control"
            errorMessage={inputError.CONFIRM_PASSWORD}
            value={addData.CONFIRM_PASSWORD}
            onChange={inputRequiredHandler}
            autoComplete="off"
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" type="general" onClick={saveBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            {/* &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; */}
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegisterUsers;
